import { createElement } from "react";
import React from "react";
import { reactApi } from "../../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { sumBy } from "../../fable_modules/fable-library-js.4.24.0/Array.js";
import { Tickets_TicketType, Tickets_TicketType_FromId_Z524259A4 } from "../../Shared/Shared.js";
import { createObj, uncurry2, int32ToString, equals } from "../../fable_modules/fable-library-js.4.24.0/Util.js";
import { useEffectWithDeps } from "../../fable_modules/Feliz.2.8.0/ReactInterop.js";
import { generateQueryString } from "../../Shared/Urls.js";
import { empty, singleton, append, delay, toArray } from "../../fable_modules/fable-library-js.4.24.0/Seq.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "../../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { Dashboard_TypeSummaryEntry_$reflection } from "../../Shared/ApiDataTypes.js";
import { obj_type, array_type } from "../../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { testRedirect, extraCoders } from "../../Promises.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { FetchError } from "../../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Result_MapError, FSharpResult$2 } from "../../fable_modules/fable-library-js.4.24.0/Result.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "../../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Types_RequestProperties } from "../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "../../fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { cons, ofArray, empty as empty_1 } from "../../fable_modules/fable-library-js.4.24.0/List.js";
import { some, unwrap, map, defaultArg } from "../../fable_modules/fable-library-js.4.24.0/Option.js";
import { toString } from "../../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { Auto_generateBoxedEncoderCached_437914C6 } from "../../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { fromString } from "../../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { createDisposable } from "../../fable_modules/Feliz.2.8.0/Internal.fs.js";
import { Components_Chip_51BC9844 } from "../Chip.js";
import { interpolate, toText } from "../../fable_modules/fable-library-js.4.24.0/String.js";

export function Tickets_WarrantyStatusCard_Z2E686B84(tickets_WarrantyStatusCard_Z2E686B84InputProps) {
    let elems;
    const machineId = tickets_WarrantyStatusCard_Z2E686B84InputProps.machineId;
    const customerId = tickets_WarrantyStatusCard_Z2E686B84InputProps.customerId;
    const groupId = tickets_WarrantyStatusCard_Z2E686B84InputProps.groupId;
    const setLoading = reactApi.useState(true)[1];
    const patternInput_1 = reactApi.useState([]);
    const setEntries = patternInput_1[1];
    const warrantyAndNonConforming = sumBy((entry) => {
        const ticketType = Tickets_TicketType_FromId_Z524259A4(entry.TypeId);
        if (equals(ticketType, new Tickets_TicketType(6, [])) ? true : equals(ticketType, new Tickets_TicketType(5, []))) {
            return entry.Num | 0;
        }
        else {
            return 0;
        }
    }, patternInput_1[0], {
        GetZero: () => 0,
        Add: (x, y) => (x + y),
    }) | 0;
    useEffectWithDeps(() => {
        let properties_2;
        const url = "/api/dashboard/type-spread" + generateQueryString(toArray(delay(() => append(singleton(["group", int32ToString(groupId)]), delay(() => {
            let matchValue;
            return append((matchValue = customerId, (matchValue != null) ? singleton(["customer", int32ToString(matchValue)]) : (empty())), delay(() => {
                const matchValue_1 = machineId;
                if (matchValue_1 != null) {
                    return singleton(["machine", int32ToString(matchValue_1)]);
                }
                else {
                    return empty();
                }
            }));
        })))));
        setLoading(true);
        let pr_2;
        let pr_1;
        const decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(Dashboard_TypeSummaryEntry_$reflection()), undefined, undefined);
        const data_1 = undefined;
        const caseStrategy_2 = undefined;
        const extra_2 = extraCoders;
        try {
            const properties_3 = Helper_withProperties(undefined, (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty_1()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
            const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(url, properties_3).then((_arg) => {
                let response_1, decoder_1_1;
                return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(Dashboard_TypeSummaryEntry_$reflection()), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => {
                    let matchValue_2;
                    return Promise.resolve((matchValue_2 = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue_2.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue_2.fields[0]])])) : (new FSharpResult$2(0, [matchValue_2.fields[0]]))));
                })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
            }))));
            pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
        }
        catch (exn) {
            pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
        }
        pr_2 = (pr_1.then((result_1) => Result_MapError(testRedirect, result_1)));
        pr_2.then((res) => {
            if (res.tag === 0) {
                setEntries(res.fields[0]);
            }
            else {
                console.error(some("Error fetching summary"), res.fields[0]);
            }
            setLoading(false);
        });
        return createDisposable(() => {
            setEntries([]);
        });
    }, [groupId, customerId, machineId]);
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: 10 + "px",
    }], (elems = [createElement(Components_Chip_51BC9844, {
        key: "waranties-open",
        $key: "waranties-open",
        primary: toText(interpolate("%d%P() Åpne avvik/garantier", [warrantyAndNonConforming])),
        enabled: true,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

